import * as React from 'react';
import { useRoute } from 'react-router5';
import { LoadingSpinner } from '../components/LoadingSpinner/LoadingSpinner';
import NotFound from '../components/NotFound/NotFound';
import { RouteName, routes } from "../router/routes";
// import { AppState } from '../state/app-state';
// import { Loadable } from '../state/loadable';
import { animatedScrollTo } from '../util/dom/animatedScrollTo';
import { CSSTransition, Transition, TransitionGroup } from 'react-transition-group';


export const ViewContainer: React.FC<Props> = (props) => {
    const route = useRoute();

    // Scroll to top of page on route changes.
    React.useEffect(() => {
        animatedScrollTo(0);
    }, [route.route.name])

    React.useEffect(() => {
        console.log("routy route")
    }, [route])

    const routeDefinition = React.useMemo(() => {
        return routes.find(r => r.name === route.route.name);
    }, [route.route.name]);

    React.useEffect(() => {
        if (routeDefinition?.redirectToHome) {
            route.router.navigate(RouteName.Base, { replace: true })
        }
    }, [routeDefinition])

    if (routeDefinition?.component) {
        const ViewComponent = routeDefinition.component;
        return <React.Suspense fallback={<LoadingSpinner />}>
            <TransitionGroup>
                <CSSTransition
                key={route.route.name}
                    timeout={750}
                    classNames={"fade"}>
                    <ViewComponent />
                </CSSTransition>
            </TransitionGroup>
        </React.Suspense>
    } else {
        console.log("not found?")
        return <NotFound />
    }
}

interface Props { }
